import React, { useState } from "react";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import { Form, Row, Col } from "react-bootstrap";
import { useForm } from "react-hook-form";
import axios from "axios";
import { showSuccessToast, showErrorToast } from "../../Utils/toastUtils";



const NewUserModal = (props) => {
    const [roles, setRoles] = useState();

    const getData = props.getData
    const modal = props.modal
    const setModal = props.setModal
    const [userName, setUserName] = useState("")
    const [userPassword, setUserPassword] = useState("")
    const [role, setRoleID] = useState("")

    const getRoles = () => {
        axios.get("/api/roles", {
            headers: {
                Authorization: 'Bearer ' + sessionStorage.getItem('userToken')
            }
        }).then((res) => {
            setRoles(res.data);
            // console.log(res.data[])
            setRoleID(res.data[0]._id)
            console.log("popo")

            console.log(res.data)
        });

    };

    const handleFormData = () => {
        if(userName.length ===0){
            showErrorToast("Input UserName");
            return
        }
        if(userPassword.length ===0){
            showErrorToast("Input User Password");
            return
        }
        if(role.length ===0){
            showErrorToast("Input Role");
            return
        }
    }

    const submit = (e) => {
        console.log("making req")
        e.preventDefault();

        handleFormData();
        const formData = {
            username: userName,
            password: userPassword,
            role: role
        }
        console.log(formData)

        axios
            .post("/api/auth/register", formData, {
                headers: {
                    Authorization: 'Bearer ' + sessionStorage.getItem('userToken')
                }
            })
            .then((response) => {
                console.log(response)
                getData()
                showSuccessToast((response.data && response.data.Message) ? response.data.Message : "Success")
            })
            .catch((err) => {
                console.log(err)

                showErrorToast("Registration Error!");
            })
        setModal(!modal)
    };
    React.useEffect(() => {
        getRoles();
    }, []);
    return (
        <div>
            <Modal size="lg" backdropClassName="" isOpen={modal} toggle={() => setModal(!modal)}>
                <ModalHeader toggle={() => setModal(!modal)}>
                    Create New User
                </ModalHeader>
                <ModalBody >
                    <form >
                        <div >
                            <div className="card card-plain">

                                <div className="card-body">
                                    <form >
                                        <div className="input-group input-group-outline mb-3">
                                            {/* <label className="form-label">Name</label> */}
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Name"
                                                onChange={(e) => setUserName(e.target.value)}
                                                required
                                            />
                                        </div>

                                        <div className="input-group input-group-outline mb-3">
                                            <input
                                                type="password"
                                                placeholder="Password"
                                                className="form-control"
                                                onChange={(e) => setUserPassword(e.target.value)}
                                                required
                                            />
                                        </div>

                                        <select
                                            className="form-select"
                                            aria-label="Default select example"
                                            // placeholder="role"
                                            onChange={(e) => setRoleID(e.target.value)}
                                            style={{ padding: "12px", color: "#495057" }}
                                        >
                                            {roles?.map((role) => {

                                                if (role.role_name !== 'Deactivate') {

                                                    return (
                                                        <option value={role._id}>
                                                            {role.role_name}
                                                        </option>
                                                    );
                                                }
                                            })}
                                        </select>
                                        <div className="text-center">
                                            <button
                                                type="submit"
                                                className="btn bg-gradient-info  my-5 mb-2"
                                                onClick={(e) => submit(e)}
                                            >
                                                Create New User
                                            </button>
                                        </div>
                                    </form>
                                </div>

                            </div>
                        </div>
                    </form>
                </ModalBody>
            </Modal>
        </div>
    );
};

export default NewUserModal;
